const handleImageUpload = (event, name, saveImage, setSrc) => {
  if (event?.target?.files?.[0]) {
    const uploadedFile = event.target.files[0]
    saveImage(name, uploadedFile, { shouldDirty: true, shouldTouch: true })

    const reader = new FileReader()
    reader.onloadend = () => {
      setSrc(reader.result)
    }
    reader.readAsDataURL(uploadedFile)
  }
}

export default handleImageUpload
